import { createContext } from 'react';

const ModalContext = createContext({ isInsideModal: false });

export default ModalContext;
